// extracted by mini-css-extract-plugin
export default {"failedProcessStepTable":"failedProcessStepTable-FfJMu","button":"button-IQSpC"};